import { BookingMeetingRoomHallBookingWrite, HallRead } from '@/api';
import useReservationStore from '@/composables/store/useReservationStore';
import useCache from '@/composables/useCache';
import helpers from '@/services/helpers';
import debounce from 'lodash/debounce';
import { computed, ref } from 'vue';
import { useStore } from '@/store';

export default function useFunctionSpacesStore() {
  const store = useStore();

  const spaces = computed(() => store.state.functionSpaces.allSpaces);
  const { reservationLocation } = useReservationStore();
  const suitable = ref<Array<HallRead>>([]);
  const loading = ref(false);

  const fetchSuitable = debounce(
    async (dayHall: BookingMeetingRoomHallBookingWrite, date: Date) => {
      loading.value = true;
      suitable.value =
        (await store.dispatch('functionSpaces/fetchSuitableSpaces', {
          locationId: reservationLocation.value?.id,
          settings: { ...dayHall, date: helpers.dateToString(date) },
        })) ?? [];
      loading.value = false;
    },
    250,
    { leading: true, trailing: true },
  );

  useCache('functionSpaces/fetchAllSpaces');

  return {
    spaces,
    fetchSuitable,
    suitable,
    loading,
  };
}
